import React, { Dispatch, SetStateAction } from 'react';
import { Button, Typography } from '@mui/material';

const CheckoutSuccess = ({
  setActiveStep,
}: {
  setActiveStep: Dispatch<SetStateAction<number>>;
}) => {
  return (
    <>
      <Typography variant="h5" gutterBottom>
        User has been updated Sucessfully!
      </Typography>
      <Button
        variant="contained"
        color="success"
        onClick={() => setActiveStep(0)}
      >
        Edit Another User
      </Button>
    </>
  );
};

export default CheckoutSuccess;
